(function () {
    'use strict';
    EO_AvatarNameController.$inject = ['$scope', '$attrs', '$element'];

    function EO_AvatarNameController($scope, $attrs, $element) {
//
        var $ctrl = this;
        $ctrl.summary = "";

        $ctrl.getSummary = function () {
            if ($ctrl.name)
                return $ctrl.name.substring(0, 1);
            else
                return "ا";
        }

    }


    var EO_AvatarName = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/avatar-name/eyeson.avatar-name.template.html',
        controller: EO_AvatarNameController,
        bindings: {
            'name': '@'
        }


    };

    angular
        .module('tikonApp')
        .component('eoAvatarName', EO_AvatarName)


})();

